import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const approveInstituteOnboarding = createAsyncThunk('approveInstituteOnboarding', async (data) => {
    try {
        const payload = {
            user_id: data?.user_id,
            status: data?.status,
        }
        if (data?.status === 'Rejected' && data?.comments) {
            payload.comments = data.comments
        }
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'approve_institute_office',
            data: payload,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
